import React from "react"

import GrantHeaderComponent from "./header-component"

class GrantHeaderContainer extends React.Component {

	render() {
		return (
			<GrantHeaderComponent {...this.props} />
		)
	}

}

export default GrantHeaderContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/grants/header-container.js